import { useInfiniteQuery } from 'react-query'
import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import {
  fetchSearchInvitationsResult,
  GetInvitationsQueryParams,
} from '@dc-shared-web/hooks/api/invitation/fetchSearchInvitationsResult'

/**
 * Custom hook to fetch invitations.
 *
 * @param params - Optional query parameters for fetching invitations.
 * @returns The result of the query, containing an array of teams or an error.
 */
export const useGetInvitations = (params?: GetInvitationsQueryParams) => {
  const apiClient = useAxiosContext()

  return useInfiniteQuery({
    queryKey: ['invitations', JSON.stringify(params)],
    queryFn: ({ pageParam = 0 }) =>
      fetchSearchInvitationsResult(apiClient, {
        ...params,
        page: pageParam + 1,
      }),
    getNextPageParam: (lastPage, pages) =>
      lastPage.meta.pages > pages.length ? pages.length : undefined,
  })
}
